import React from 'react';
import { UserEntity } from 'Models/Entities';
import {
	RegisterCustomerStep,
	RegisterCustomerStepFooter,
} from 'Views/Components/_HumanWritten/RegisterCustomer/RegisterCustomerStep';
import { useAnytimeTicketStore } from '../State/AnytimeTicketContext';

const REGISTER_CUSTOMER_FORM_ID = 'anytime-ticket-register-customer';

export default function AnytimeTicketRegisterCustomerStep() {
	const completeRegisterCustomer = useAnytimeTicketStore(s => s.completeRegisterCustomer);
	const setRegisterCustomerLoading = useAnytimeTicketStore(s => s.setRegisterCustomerLoading);

	return (
		<RegisterCustomerStep
			formId={REGISTER_CUSTOMER_FORM_ID}
			onSuccess={(customer: UserEntity) =>
				completeRegisterCustomer({
					id: customer.id,
					firstName: customer.firstName,
					lastName: customer.lastName,
					email: customer.email,
				})
			}
			onLoadingChange={setRegisterCustomerLoading}
		/>
	);
}

AnytimeTicketRegisterCustomerStep.Footer = function AnytimeTicketRegisterCustomerFooter() {
	const cancelRegisterCustomer = useAnytimeTicketStore(s => s.cancelRegisterCustomer);
	const registerCustomerLoading = useAnytimeTicketStore(s => s.registerCustomerLoading);

	return (
		<RegisterCustomerStepFooter
			formId={REGISTER_CUSTOMER_FORM_ID}
			onBack={cancelRegisterCustomer}
			loading={registerCustomerLoading}
		/>
	);
};
